import React, { useState, useEffect } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  message,
  Modal,
  DatePicker,
  Select,
  Rate,
} from "antd";

import { API_LIST_REVIEWS, API_ADD_COMMENT } from "api/Reviews";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaRegCommentAlt } from "react-icons/fa";
import { API_LIST_USER } from "api/user-mangement";

const { Column } = Table;
const { RangePicker } = DatePicker;
const { Option } = Select;

const ReviewsTable = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 8 });
  const [searchName, setSearchName] = useState("");

  const [dataUser, setDataUser] = useState([]);
  const [loadingUser, setLoadingUser] = useState(false);

  const [paginationUser, setPaginationUser] = useState({
    current: 1,
    pageSize: 8,
    total: 0,
    totalPages: 0,
  });

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [comments, setComments] = useState([]);
  const [myComment, setMycomment] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [minRating, setMinRating] = useState(null);
  const [maxRating, setMaxRating] = useState(null);
  const [sortField, setSortField] = useState("overall_review");
  const [sortOrder, setSortOrder] = useState("asc");
  const [reviewer, setReviewer] = useState("");

  const { t } = useTranslation();
  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      setLoading(true);
      const params = {
        page: pagination.current,
        limit: pagination.pageSize,
        name: searchName,
        startDate: startDate ? startDate.format("YYYY-MM-DD") : undefined,
        endDate: endDate ? endDate.format("YYYY-MM-DD") : undefined,
        minRating: minRating || undefined,
        maxRating: maxRating || undefined,
        sortField,
        sortOrder,
        reviewer: reviewer || undefined,
      };
      const newData = await API_LIST_REVIEWS(params);
      console.log("reviews ==>", newData);
      setData(newData);
      setLoading(false);
      setPagination({ ...pagination, total: newData.reviews });
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    pagination.current,
    pagination.pageSize,
    searchName,
    startDate,
    endDate,
    minRating,
    maxRating,
    sortField,
    sortOrder,
    reviewer,
  ]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const handleDelete = async (data) => {
    console.log("data ---", data);
    setComments(data);
    setIsModalVisible(!isModalVisible);
  };

  const commentAdd = async () => {
    try {
      const payload = {
        comment: myComment,
        review_id: comments?._id,
      };
      let q = await API_ADD_COMMENT(payload);
      message.success(q?.message);
      setComments((prevComments) => ({
        ...prevComments,
        comments: [...prevComments.comments, { comment: myComment }],
      }));
      setMycomment("");
      fetchData();
    } catch (error) {
      console.error("Error adding comment:", error);
      message.error("Failed to add comment");
    }
  };

  const getRowClassName = (record, index) => {
    return index % 2 === 0 ? "even-row" : "odd-row";
  };
  const fetchUserList = async (page = 1, pageSize = 8) => {
    console.log("page ==>", page, pageSize);
    try {
      setLoadingUser(true);
      const params = {
        page,
        limit: pageSize,
      };
      const response = await API_LIST_USER(params);
      const { users, totalPages, totalUsers } = response; // Adjusting according to API response
      setDataUser((prevUserList) => [...prevUserList, ...users]);
      setPaginationUser((prevPagination) => ({
        ...prevPagination,
        current: page,
        total: totalUsers,
        totalPages: totalPages,
      }));
      setLoadingUser(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoadingUser(false);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, []);

  console.log("userData", dataUser);
  return (
    <div>
      <div className="mb-4 flex justify-between">
        <Space>
          <RangePicker
          placeholder={[t("Start Date"), t("End Date")]}
          onChange={(dates) => {
              setStartDate(dates ? dates[0] : null);
              setEndDate(dates ? dates[1] : null);
            }}
            style={{ width: 250 }}
          />
          <Input
            type="number"
            placeholder={t("Min Rating")}
            onChange={(e) => setMinRating(e.target.value)}
            style={{ width: 120 }}
          />
          <Input
            type="number"
            placeholder={t("Max Rating")}
            onChange={(e) => setMaxRating(e.target.value)}
            style={{ width: 120 }}
          />
          <Select
            defaultValue="overall_review"
            onChange={(value) => setSortField(value)}
            style={{ width: 180 }}
          >
            <Option value="overall_review">{t("Overall Review")}</Option>
            <Option value="application_review">{t("Application Review")}</Option>
            <Option value="service_review">{t("Service Review")}</Option>
          </Select>
          <Select
            defaultValue="asc"
            onChange={(value) => setSortOrder(value)}
            style={{ width: 120 }}
          >
            <Option value="asc">{t("Ascending")}</Option>
            <Option value="desc">{t("Descending")}</Option>
          </Select>

          <Select
            placeholder={t("Select Reviewer")}
            onChange={(value) => setReviewer(value)}
            style={{ width: 180 }}
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().includes(input.toLowerCase())
            }
            onDropdownVisibleChange={(open) => {
              if (open && paginationUser.current < paginationUser.totalPages) {
                fetchUserList(
                  paginationUser.current + 1,
                  paginationUser.pageSize
                );
              }
            }}
            onPopupScroll={(e) => {
              const { target } = e;
              if (
                target.scrollTop + target.offsetHeight ===
                target.scrollHeight
              ) {
                if (paginationUser.current < paginationUser.totalPages) {
                  fetchUserList(
                    paginationUser.current + 1,
                    paginationUser.pageSize
                  );
                }
              }
            }}
            loading={loadingUser}
          >
            {dataUser?.map((user) => (
              <Option key={user?.id} value={user?._id}>
                {user?.first_name}
              </Option>
            ))}
          </Select>
        </Space>
      </div>
      <Table
        dataSource={data?.reviews}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowKey={(record) => record.id}
        rowClassName={getRowClassName}
        scroll={{ x: true }}
      >

        <Column
          title={t("Application Review")}
          dataIndex="reviewer_info"
          key="reviewer_info"
          render={(text, record) => (
            <div>
              <div>{record?.application_review?.comment} </div>
              <div>
                <Rate
                  allowHalf
                  defaultValue={record?.application_review?.review}
                  disabled
                />
              </div>
            </div>
          )}
        />
        <Column
          title={t("Delivery Driver Review")}
          dataIndex="delivery_driver_review"
          key="delivery_driver_review"
          render={(text, record) => (
            <div>
              <div>
                {record?.delivery_driver_review?.driver_info?.first_name +
                  " " +
                  record?.delivery_driver_review?.driver_info?.last_name}{" "}
              </div>
              <div>{record?.delivery_driver_review?.comment} </div>
              <div>
                <Rate
                  allowHalf
                  defaultValue={record?.delivery_driver_review?.review}
                  disabled
                />
              </div>
            </div>
          )}
        />
        <Column
          title={t("Pickup Driver Review")}
          dataIndex="pickup_driver_review"
          key="pickup_driver_review"
          render={(text, record) => (
            <div>
              <div>
                {record?.pickup_driver_review?.driver_info?.first_name +
                  " " +
                  record?.pickup_driver_review?.driver_info?.last_name}{" "}
              </div>
              <div>{record?.pickup_driver_review?.comment} </div>
              <div>
                <Rate
                  allowHalf
                  defaultValue={record?.pickup_driver_review?.review}
                  disabled
                />
              </div>
            </div>
          )}
        />
        <Column
          title={t("Service Review")}
          dataIndex="service_review"
          key="service_review"
          render={(text, record) => (
            <div>
              <div>{record?.service_review?.comment} </div>
              <div>
                <Rate
                  allowHalf
                  defaultValue={record?.service_review?.review}
                  disabled
                />
              </div>
            </div>
          )}
        />
        <Column
          title={t("Overall Review")}
          dataIndex="overall_review"
          key="overall_review"
          render={(text, record) => (
            <div>
              <div>{record?.overall_review?.comment} </div>
              <div>
                <Rate
                  allowHalf
                  defaultValue={record?.overall_review?.review}
                  disabled
                />
              </div>
            </div>
          )}
        />
        <Column
          title={t("Comments")}
          key="actions"
          render={(text, record) => (
            <div>
              <Button
                type="danger"
                icon={<FaRegCommentAlt />}
                style={{ border: "1px solid #d9d9d9", marginLeft: "5px" }}
                onClick={() => handleDelete(record)}
              ></Button>{" "}
            </div>
          )}
        />
      </Table>
      <Modal
        title={t("Comments")}
        visible={isModalVisible}
        onOk={() => setIsModalVisible(false)}
        onCancel={() => setIsModalVisible(false)}
      >
        <ul>
          {comments?.comments?.map((comment, index) => (
            <li key={index}>{comment?.comment}</li>
          ))}
        </ul>
        <input
          className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white p-3 text-sm outline-none"
          placeholder={t("please enter your comment here")}
          value={myComment}
          onChange={(a) => {
            setMycomment(a.target.value);
          }}
        />
        <div className="flex justify-end">
          <button
            type="button"
            className="linear mt-2 w-full max-w-[10rem] rounded-xl bg-brand-500 py-[8px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            onClick={commentAdd}
          >
            {t("Add Comment")}
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ReviewsTable;
